/**
 * decodeHtmlEntities
 */

import { stringify } from "query-string";

export function decodeHtmlEntities(text) {
  if (typeof text !== 'string') {
    throw new Error(`Failed to decode HTML entity: invalid type ${typeof text}`);
  }

  let decoded = text;

  const entities = {
    '&amp;': '\u0026',
    '&quot;': '\u0022',
    '&#039;': '\u0027',
  };

  return decoded.replace(/&amp;|&quot;|&#039;/g, (char) => entities[char]);
}

/**
 * removeLastTrailingSlash
 */

export function removeLastTrailingSlash(url) {
  if (typeof url !== 'string') return url;
  return url.replace(/\/$/, '');
}

export function removeExtraSpaces(text) {
  if (typeof text !== 'string') return;
  return text.replace(/\s+/g, ' ').trim();
}

export function getQueryString(obj, withoutQuestion = false) {
  let newObj = {}
    Object.keys(obj).map(k => {
      if (obj[k]) {
        newObj[k] = obj[k]
      }
    })
    let queryString = ''
    if (Object.keys(newObj).length > 0) {
      queryString = withoutQuestion ? `${stringify(newObj)}` : `?${stringify(newObj)}`;
    }
    return queryString
}

export function setCookie(name, value, days) {
  let expires = "";
  if (days) {
      let date = new Date();
      date.setTime(date.getTime() + (days*24*60*60*1000));
      expires = "; expires=" + date.toUTCString();
  }
  document.cookie = name + "=" + (value || "")  + expires + "; path=/";
}

export function toNumberFormat(number) {
  let nf = new Intl.NumberFormat();
  return nf.format(number);
} 

export function revalidateTime(minute) {
  return minute * 60
}